import { gql } from "gql";

export const GET_TASK_BY_ID = gql(/* GraphQL */ `
  query GetTaskById($id: ID!, $commentSort: CommentTaskSort) {
    getTaskById(id: $id) {
      ...TaskCard
    }
  }
`);
